import { useEffect, useState, useRef, useContext } from 'react';
import '../../../styles/game/GameBoard.css';
import { useData, useSocket } from '../../../providers/SocketContext.jsx'
import { MenuButtons } from '../../../providers/MenuButtonsContext.jsx';


function Aviator({isGameState, chatBar}) {
    const { isSoundOn, setIsSoundOn, isMusicOn, setIsMusicOn, isAnimationOn, setIsAnimationOn } = useContext(MenuButtons)
    const canvasRef = useRef(null);
    const imagesRef = useRef([]);
    const startTime = useRef(null);
    const startTime2 = useRef(null);
    const speed = useRef(null);
    const t = useRef(0);
    const isReverse = useRef(false)
    const animationStartTime = useRef(null);
    const trailPath = useRef([]);
    const planePosition = useRef({x:0, y:0});
    const linearT = useRef(0)
    const t1 = useRef(null);
    const linearT2 = useRef(0);
    const t2 = useRef(null);
    const animationIdRef = useRef(null);
    const duration = 11000; // Длительность анимации (8 секунд)
    const duration2 = 5000;
    const animationId = useRef(null);
    const currentPlaneImage = useRef(null);
    const planeAnimationId = useRef(null);
    const [imagesIsLoading, setImagesIsLoading] = useState(false)
    const frameIndex = useRef(0)
    const elapsed = useRef(null)
    const lastFrameTime = useRef(0)
    const frameDuration = 150
    const currentFrame = useRef(0)
    const [x20, setX20] = useState(0)
    const [y20, setY20] = useState(0)
    const [planeWidth, setPlaneWidth] = useState(150)
    const [planeHeight, setPlaneHeight] = useState(75)
    const [totalWidth, setTotalWidth] = useState(null)

    const audioRef = useRef(null);
    const flewAudioRef = useRef(null)

    useEffect(() => {
        const canvas = canvasRef.current
        const context = canvas.getContext('2d');

        const loadImages = () => {
            const sources = [
                '/assets/img/plane-0.svg',
                '/assets/img/plane-1.svg',
                '/assets/img/plane-2.svg',
                '/assets/img/plane-3.svg',
            ];
        
            sources.forEach((src, index) => {
                const img = new Image();
                img.src = src;
                img.onload = () => {
                    imagesRef.current[index] = img;
                };
                img.onerror = () => {
                    console.error(`Failed to load image: ${src}`);
                };
            });
        };


  
        
        //   if(totalWidth > 850) {
        //     setPlaneWidth(150)
        //     setPlaneHeight(75)
        //   } else if(totalWidth < 850 && totalWidth > 800) {
        //     setPlaneWidth(135)
        //     setPlaneHeight(67.5)
        //   } else if(totalWidth < 800 && totalWidth > 700) {
        //     setPlaneWidth(120)
        //     setPlaneHeight(60)
        //   } else if (totalWidth < 700) {
        //     setPlaneWidth(105)
        //     setPlaneHeight(52.5)
        //   }
        

        // console.log(totalWidth)
        function startPlaneAnimation(images, frameDuration) {
            let frameIndex = 0; // Начальный индекс изображения
            let lastFrameTime = 0; // Время последней смены изображения
        
            // Устанавливаем анимацию кадров
            function updatePlaneImage(timestamp) {
                if (!lastFrameTime) lastFrameTime = timestamp; // Инициализируем время
        
                const elapsed = timestamp - lastFrameTime; // Вычисляем время с последнего кадра
        
                if (elapsed >= frameDuration) {
                    frameIndex = (frameIndex + 1) % images.length; // Переходим к следующему кадру
                    currentPlaneImage.current = frameIndex; // Обновляем текущее изображение
                    lastFrameTime = timestamp; // Обновляем время последнего кадра
                }
                
                planeAnimationId.current = requestAnimationFrame(updatePlaneImage); // Рекурсивно запускаем следующий кадр
                
            }
        
            // Инициализируем анимацию
            planeAnimationId.current = requestAnimationFrame(updatePlaneImage);
            

        }


        

        function resizeCanvas() {
            // Устанавливаем CSS-стили
            canvas.style.width = '100%';
            canvas.style.height = '100%';
            const newWidth = canvas.offsetWidth;
            setTotalWidth(newWidth); // Обновляем состояние
          
            // Используем локальное значение, чтобы избежать проблем с асинхронностью
            if (newWidth > 850) {
              setPlaneWidth(150);
              setPlaneHeight(75);
            } else if (newWidth <= 850 && newWidth > 800) {
              setPlaneWidth(135);
              setPlaneHeight(67.5);
            } else if (newWidth <= 800 && newWidth > 600) {
              setPlaneWidth(120);
              setPlaneHeight(60);
            } else if (newWidth <= 600) {
              setPlaneWidth(105);
              setPlaneHeight(52.5);
            }

            // Учитываем устройство с высоким pixelRatio
            const pixelRatio = window.devicePixelRatio || 1;
          
            // Устанавливаем реальные размеры canvas
            canvas.width = canvas.offsetWidth * pixelRatio;
            canvas.height = canvas.offsetHeight * pixelRatio;
          
            // Масштабируем контекст для чёткого отображения
            context.scale(pixelRatio, pixelRatio);

            

          
            // Перерисовываем кривую
            // drawBezierCurve();
          }






          function bezierPoint(t, p0, p1, p2, p3) {
            // Формула Безье для вычисления координат
            return (
              Math.pow(1 - t, 3) * p0 +
              3 * Math.pow(1 - t, 2) * t * p1 +
              3 * (1 - t) * Math.pow(t, 2) * p2 +
              Math.pow(t, 3) * p3
            );
          }





          function easeOutQuad(t) {
            return 1 - Math.pow(1 - t, 2.5); // Ускорение в начале и замедление в конце
          }



          function updateBezierTrail() {
            // Вычисляем текущую позицию самолета
            const x = planePosition.current.x
            const y = planePosition.current.y
            const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
            const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота

          if(x < width * 0.2) {
          
            context.beginPath();
            context.moveTo(x20, height - y20); 
            context.lineTo(x + 20, y - 3)
          
          
            context.strokeStyle = '#E50539'; // Цвет линии
            context.lineWidth = 4; // Толщина линии
            context.stroke();
            
          } else {
            context.beginPath();
            context.moveTo(x20, height - y20); // Начальная точка M
            context.quadraticCurveTo(
              x * 0.5, height - y20,      // Первая контрольная точка C1
              // Вторая контрольная точка C2
              x + 20, y - 3    // Конечная точка
            );
          
          
            context.strokeStyle = '#E50539'; // Цвет линии
            context.lineWidth = 4; // Толщина линии
            context.stroke();
          }
          
            context.quadraticCurveTo(
              x * 0.5, height - y20,      // Первая контрольная точка C1
                    // Вторая контрольная точка C2
                    x + 20, y - 3     // Конечная точка
            );
            context.lineTo(x + 20, height - y20); // Линия вниз к нижней границе canvas
            context.lineTo(x20, height - y20); // Линия к основанию начальной точки
            context.closePath(); // Замыкаем путь
          
            // Заливаем замкнутую область
            context.fillStyle = '#e5053970'; // Полупрозрачный синий цвет
            context.fill();
          
          }




          function easeInOutQuad(t) {
            return t < 0.5
              ? 2 * t * t // Ускорение в начале
              : 1 - Math.pow(-2 * t + 2, 2) / 2; // Замедление в конце
          }






          function animate(timestamp) {

            frameIndex.current = Math.floor((elapsed.current / 150) % imagesRef.current.length);
            currentPlaneImage.current = imagesRef.current[frameIndex.current];

            if (isGameState === 'active') {
                if (linearT.current < 1) {
                    if (!startTime.current) startTime.current = timestamp;
                    elapsed.current = timestamp - startTime.current;
                  
                    // Нормализуем t от 0 до 1
                    linearT.current = Math.min(elapsed.current / duration, 1);
                    t1.current = easeOutQuad(linearT.current); // Применяем easing
                    
                  
                  
                    // Используем реальную ширину и высоту
                    const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
                    const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота
                  
                    //   
                    const startX = 0, startY = height;
                    const c1X = width * 0.4, c1Y = height - y20;
                    const c2X = width * 0.4, c2Y = height - y20;
                    const endX = width - (planeWidth * 1.5), endY = planeHeight + 5;
                  
                    // Очищаем холст перед каждым кадром
                    context.clearRect(0, 0, width, height);
                  
                    // Рисуем кривую
                  
                  
                    // Вычисляем текущие координаты
                    const x = bezierPoint(t1.current, startX, c1X, c2X, endX);
                    const y = bezierPoint(t1.current, startY, c1Y, c2Y, endY);
                    planePosition.current.x = x;
                    planePosition.current.y = y;
                    updateBezierTrail(t1.current, startX, startY, c1X, c1Y, c2X, c2Y, endX, endY);
                      // Вычисляем текущий кадр анимации (меняем каждую 0.2 секунды)
                  
                    // Рисуем изображение
                    if (currentPlaneImage.current instanceof HTMLImageElement) {
                      context.drawImage(currentPlaneImage.current, x, y - planeHeight, planeWidth, planeHeight); // Центрируем изображение
                  } else {
                      console.warn('currentImage is not a valid HTMLImageElement:', currentPlaneImage.current);
                  }
                    
                    // Если анимация не закончена, продолжаем
                    
                  } else if (linearT.current >= 1) {
                   
                    if (!startTime2.current) startTime2.current = timestamp;
                    if (!animationStartTime.current) animationStartTime.current = timestamp; // Инициализируем начало смены кадров
                    
                    elapsed.current = timestamp - startTime2.current;
                    const frameElapsed = timestamp - animationStartTime.current; // Время с начала смены кадров
                  
                    // Нормализуем t от 0 до 1
                     linearT2.current = Math.min(elapsed.current / duration2, 1);
                     t2.current = easeInOutQuad(linearT2.current); // Применяем easing для плавного начала и конца
                  
                    // Используем реальную ширину и высоту
                    const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
                    const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота
                  
                    // Начальная и конечная точки прямой линии
                    const startX = width - (planeWidth * 1.5), startY = planeHeight + 5;
                    const endX = width - planeWidth - 15, endY = planeHeight * 3 > canvasRef.current.offsetHeight ? canvasRef.current.offsetHeight - planeHeight : planeHeight * 3;
                  
                    // Вычисляем текущие координаты на прямой линии
                    const currentT = isReverse.current ? 1 - t2.current : t2.current; // Меняем направление при обратном движении
                    const x = startX + currentT * (endX - startX);
                    const y = startY + currentT * (endY - startY);
                    planePosition.current.x = x;
                    planePosition.current.y = y;
                  
                      const c1X = width * 0.3, c1Y = height - y20;
                      const c2X = width * 0.3, c2Y = height - y20;
                  
                    // Очищаем холст перед каждым кадром
                    context.clearRect(0, 0, width, height);
                    updateBezierTrail(t2.current, startX, startY, c1X, c1Y, c2X, c2Y, endX, endY);
                    // Рисуем кривую и прямую для визуализации
                  
                  
                    // Вычисляем текущий кадр анимации (меняем каждые 0.2 секунды)

                  
                    // Рисуем изображение
                    if (currentPlaneImage.current instanceof HTMLImageElement) {
                      context.drawImage(currentPlaneImage.current, x, y - planeHeight, planeWidth, planeHeight); // Центрируем изображение
                  } else {
                      console.warn('currentImage is not a valid HTMLImageElement:', currentPlaneImage.current);
                  }
                    
                    // Если анимация завершена (linearT >= 1)
                    if (linearT2.current >= 1) {
                      // Переключаем направление
                      isReverse.current = !isReverse.current;
                      startTime2.current = null; // Сбрасываем время для движения
                    }
                  }
            } 
            else if (isGameState === 'waiting') {
                const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
                const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота
                context.clearRect(0, 0, width, height);
                if (!startTime.current) startTime.current = timestamp;
                elapsed.current = timestamp - startTime.current;
                if (planePosition.current.x < width + 200) {
                    planePosition.current.x += 20;
                    planePosition.current.y -= 5;
            
                }
                
                context.drawImage(currentPlaneImage.current, planePosition.current.x, planePosition.current.y - planeHeight, planeWidth, planeHeight);
                
            } else if (isGameState === 'countdown') {
                const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
                const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота
                if (timestamp - lastFrameTime.current >= frameDuration) {
                    currentFrame.current = (currentFrame.current + 1) % imagesRef.current.length; // Смена кадра
                    lastFrameTime.current = timestamp;
                }
                
                startTime.current = null;
                startTime2.current = null;
                t.current = 0;
                isReverse.current = false
                animationStartTime.current = null;
                trailPath.current = [];
                planePosition.current = {x: 0, y: height};
                linearT.current = 0
                t1.current = null;
                linearT2.current = 0;
                t2.current = null;
                animationIdRef.current = null;
                context.clearRect(0, 0, width, height);
                if (imagesRef.current[currentFrame.current] instanceof HTMLImageElement) {
                    context.drawImage(imagesRef.current[currentFrame.current], planePosition.current.x, planePosition.current.y - planeHeight, planeWidth, planeHeight);
                } else {
                    console.warn('currentImage is not a valid HTMLImageElement:', currentPlaneImage.current);
                }
            
                
            }
            
            
            animationId.current = requestAnimationFrame(animate);
          
          }





          function drawBezierCurve() {
            // Используем логические размеры для вычисления
            const width = canvas.width / (window.devicePixelRatio || 1); // Логическая ширина
            const height = canvas.height / (window.devicePixelRatio || 1); // Логическая высота
          
            context.beginPath();
            context.moveTo(x20, height - y20); // Начальная точка M
            context.bezierCurveTo(
              width * 0.3, height - y20,      // Первая контрольная точка C1
              width * 0.3, height - y20,      // Вторая контрольная точка C2
              width * 0.8, height * 0.125    // Конечная точка
            );
          
            // Настраиваем стиль линии
            context.strokeStyle = 'red';
            context.lineWidth = 3;
          
            // Рисуем кривую
          
          
            context.beginPath();
            context.moveTo(width * 0.8, height * 0.125)
            context.lineTo(width * 0.85, height * 0.4);
            context.strokeStyle = 'red';
            context.lineWidth = 3;
          
          }





          window.addEventListener('resize', resizeCanvas);
          if (!imagesIsLoading) {
            loadImages()
            setImagesIsLoading(true)
          }
          resizeCanvas();


            

            if(isAnimationOn) {
              animationId.current = requestAnimationFrame(animate);
            } else {
              if(animationId.current) {
                cancelAnimationFrame(animationId.current)
              }
            }




          return () => {
            window.removeEventListener('resize', resizeCanvas);
            cancelAnimationFrame(animationId.current)
            
          };

    }, [isGameState, chatBar, totalWidth, isAnimationOn])

    useEffect(() => {
      // Проверяем изменение isGameState
      if(isSoundOn) {
        if (isGameState === 'active') {
          
    
          const audio = audioRef.current;
    
          // Запускаем аудио
          if (audio) {
            audio.currentTime = 0; // Сброс на начало
            audio.volume = 0.4;
            audio.play().catch((error) => {
              console.error("Ошибка воспроизведения звука:", error);
            });
          }
        }
        if(isGameState === 'waiting') {
          const audio = flewAudioRef.current;

          // Запускаем аудио
          if (audio) {
            audio.currentTime = 0; // Сброс на начало
            audio.volume = 0.4;
            audio.play().catch((error) => {
              console.error("Ошибка воспроизведения звука:", error);
            });
          }
        }
      }
    }, [isGameState]); // Отслеживаем изменения isGameState

    // useEffect(() => {
    //   if(!totalWidth) {
    //     return
    //   }

    //   if(totalWidth < 850) {
    //     setPlaneWidth(120)
    //     setPlaneHeight(60)
    //   }
    // }, [totalWidth])



    return (
        <> 
            <div className={'aviator-wrapper'}>
                <canvas
                ref={canvasRef}></canvas>
                    <audio ref={audioRef} style={{ display: "none" }}>
                      <source src="/assets/audio/round_start.mp3" type="audio/mpeg" />
                  </audio>
                  <audio ref={flewAudioRef} style={{ display: "none" }}>
                      <source src="/assets/audio/flew_away.mp3" type="audio/mpeg" />
                  </audio>
            </div>
        </>
    )
}

export default Aviator;